import OutputControlSection from './OutputControlSection'

export default OutputControlSection
